import { thirdWebClient, chain } from "@/app/libs/thirdweb";
import { SPON } from "@/contracts/addresses";
import { getContract, readContract } from "thirdweb";
import { Account } from "thirdweb/wallets";

/**
 * Fetches the SPON token balance of an account using readContract.
 *
 * @param account - The address to fetch the balance for.
 * @returns A promise that resolves to the balance in bigint.
 */
export async function getSPONBalance(account: Account): Promise<bigint> {
  try {
    const contract = getContract({
      client: thirdWebClient,
      chain,
      address: SPON,
    });

    const balance: bigint = await readContract({
      contract,
      method: {
        type: "function",
        name: "balanceOf",
        inputs: [
          { name: "_account", type: "address", internalType: "address" },
        ],
        outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
        stateMutability: "view",
      },
      params: [account.address],
    });

    console.log(`SPON Balance for ${account.address}:`, balance);
    return balance;
  } catch (error) {
    console.error("Error fetching balance:", error);
    throw error;
  }
}